'use client';
import { useState } from 'react';

import Button from '@gds/Button/Button';

import styles from './PlpIntro.module.css';

type PlpIntroClientProps = {
  strings: {
    readMoreCta: string;
    readLessCta: string;
    makeModelIntro: string;
  };
};

const PlpIntroClient = ({ strings }: PlpIntroClientProps) => {
  const [isExpanded, setExpanded] = useState(false);
  const toggleSection = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setExpanded(e => !e);
  };
  return (
    <div className={`${styles.makeModelIntro} ${isExpanded ? styles.expanded : ''}`}>
      <div className={`${styles.copy} ${isExpanded ? styles.expanded : ''}`}>
        {strings.makeModelIntro}
      </div>
      <Button
        variant="link"
        onClick={toggleSection}
        className={`${styles.viewMore} ${isExpanded ? styles.expanded : ''}`}
      >
        {isExpanded ? strings.readLessCta : strings.readMoreCta}
      </Button>
    </div>
  );
};

export { PlpIntroClient };
